import { c as _c } from "react/compiler-runtime";
import { IconButton, Tooltip, type IconButtonProps } from '@mui/material';
import { forwardRef } from 'react';
interface ExtendedIconButtonProps extends IconButtonProps {
  tooltip?: React.ReactNode;
}
export const ExtendedIconButton = forwardRef<HTMLButtonElement, ExtendedIconButtonProps>(function ExtendedIconButton(props, ref) {
  const $ = _c(10);
  let iconButtonProps;
  let tooltip;
  if ($[0] !== props) {
    const {
      tooltip: t0,
      children,
      ...t1
    } = props;
    tooltip = t0;
    iconButtonProps = t1;
    $[0] = props;
    $[1] = iconButtonProps;
    $[2] = tooltip;
  } else {
    iconButtonProps = $[1];
    tooltip = $[2];
  }
  let t0;
  if ($[3] !== iconButtonProps || $[4] !== props.children || $[5] !== ref) {
    t0 = <span><IconButton {...iconButtonProps} ref={ref} size="small" color="primary">{props.children}</IconButton></span>;
    $[3] = iconButtonProps;
    $[4] = props.children;
    $[5] = ref;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  let t1;
  if ($[7] !== t0 || $[8] !== tooltip) {
    t1 = <Tooltip title={tooltip}>{t0}</Tooltip>;
    $[7] = t0;
    $[8] = tooltip;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  return t1;
});